import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNavLocked: false,
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setNavLocked: (state, action) => {
      state.isNavLocked = action.payload;
    },
    toggleNavLocked: (state) => {
      state.isNavLocked = !state.isNavLocked;
    },
  },
});

export const { setNavLocked, toggleNavLocked } = navigationSlice.actions;
export default navigationSlice.reducer;
